<li class="nav-item">
    <button class="nav-link btn btn-dark text-white mr-2" (click)="openKindModal()"><i class="fa fa-exchange" aria-hidden="true"></i> {{ "changeAtype" | language }}</button>
</li>
<app-kindsmodal [id]="'atypesListModal'"></app-kindsmodal>